import httpClient from "@/apis/base/axios-httpclient";
import api from "@/apis/AssetAPI";
import Crud from "./crud-base";
var crud = new Crud("Asset", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "AssetID",
      code: "AssetCode",
      name: "AssetName",
      quantity: "Quantity",
    },
  },
  brokens: [],
  asset: [],
  assetByID: [],
  totals: [],
};
const getters = {
  ...crud.getters,
  brokens: function (state) {
    return state.brokens;
  },

  totals: function (state) {
    return state.totals;
  },
  assetByID: function (state) {
    return state.assetByID;
  },
};
const actions = {
  ...crud.actions,
  loadListBrokenAsset: async function (context, payload) {
    context.commit("updateLoading", true);
    let url = [api.getAPIUrl(), "broken"];
    if (payload == true) {
      url.push(true);
    }
    let request = {
      url: url.join("/"),
    };
    let res = await httpClient.getAsync(request);
    context.commit("updateLoading", false);
    if (res) {
      context.commit("updateBrokenAsset", res);
      return res;
    }
  },

  loadAssetByAssetID: async function (context, payload) {
    let request = {
      url: [api.getAPIUrl(), "asset", payload].join("/"),
    };
    let res = await httpClient.getAsync(request);
    context.commit("updateLoading", false);
    if (res) {
      context.commit("updateAssetByID", res);
      return res;
    }
  },

  loadAssetByEmployeeID: async function (context, payload) {
    let request = {
      url: [api.getAPIUrl(), "employee", payload].join("/"),
    };
    return await httpClient.getAsync(request);
  },

  loadAssetByOrganizationID: async function (context, payload) {
    let request = {
      url: [api.getAPIUrl(), "organization-unit", payload].join("/"),
    };
    return await httpClient.getAsync(request);
  },

  loadTotal: async function (context, payload) {
    context.commit("updateLoading", true);
    let url = [api.getAPIUrl(), "total"];
    if (payload == true) {
      url.push(true);
    }
    let request = {
      url: url.join("/"),
    };
    let res = await httpClient.getAsync(request);
    context.commit("updateLoading", false);
    if (res) {
      context.commit("updateTotal", res);
      return res;
    }
  },
  /*
   *  pvduy 04/03/2021: thực hiện cất từng field
   */
  updateField: async function (context, payload) {
    // payload = {id: 1, field: 'AssetName', value: '213'};
    context.commit("updateLoading", true);
    let url = [api.getAPIUrl(), "field", payload.id, payload.field].join("/");
    let data = {};
    data[payload.field] = payload.value;
    let request = {
      url: url,
      data: data,
    };
    try {
      let res = await httpClient.putAsync(request);
      let updateData = {
        AssetId: payload.id,
      };
      updateData[payload.field] = payload.value;
      context.commit("updateField", updateData);

      return res;
    } catch (err) {
      console.error(err);
    } finally {
      context.commit("updateLoading", false);
    }
  },

  /**
   * Lấy danh sách tài sản theo vị trí và tình trạng của tài sản
   * @param {} context
   * @param {*} payload
   * @returns
   */
  loadAssetsIsNotUsedByLocationId: async function (context, payload) {
    let url = [api.getAPIUrl(), "get-assets-is-not-used-by-locationid"].join("/");
    let request = {
      url: url,
      data: payload,
    };
    let res = await httpClient.postAsync(request, true);
    return res;
  },

  loadAssetsIsUsedByLocationId: async function (context, payload) {
    let url = [api.getAPIUrl(), "get-assets-is-used-by-locationid"].join("/");
    let request = {
      url: url,
      data: payload,
    };
    let res = await httpClient.postAsync(request, true);
    return res;
  },
};
const mutations = {
  ...crud.mutations,
  updateBrokenAsset(state, res) {
    state.brokens.removeAll();
    state.brokens.append(res);
  },
  updateAssetByID(state, res) {
    state.assetByID.removeAll();
    state.assetByID.append(res);
  },

  updateTotal(state, res) {
    state.totals.removeAll();
    state.totals.append(res);
  },
  /*
   * pvduy 04/03/2021: thực hiện cất từng field
   */
  updateField(state, data) {
    let id = data.AssetId;
    for (let i = 0; i < state.items.length; i++) {
      let item = state.items[i];
      if (item.AssetID === id) {
        Object.assign(item, data);
      }
    }
  },
  /*
   * nnlam 04/03/2021: thực hiện update item theo key ( do 1 số màn cùng 1 tài sản nhưng có nhiều dòng giống nhau)
   */
  updateItemByKey(state, res) {
    let data = res.data,
      key = res.key || "AssetID",
      index = res.index; //vì 1 tài sản ở 1 số màn bị tách thành nhiều bản ghi, nên dựa vào index để update
    let id = data[key];
    if (index != null && index != undefined) {
      // bằng 0 vẫn ok nhé
      let item = state.items[index];
      if (item[key] === id) {
        Object.assign(item, data);
      }
    } else {
      for (let i = 0; i < state.items.length; i++) {
        let item = state.items[i];
        if (item[key] === id) {
          Object.assign(item, data);
        }
      }
    }
  },

  /*
   * nnlam 04/03/2021: thực hiện update các field theo key ( do 1 số màn cùng 1 tài sản nhưng có nhiều dòng giống nhau)
   */
  updateFieldsByKey(state, res) {
    let data = res.data,
      key = res.key || "AssetID",
      index = res.index; //vì 1 tài sản ở 1 số màn bị tách thành nhiều bản ghi, nên dựa vào index để update
    let id = data[key],
      fields = res.fields || [];
    if (index != null && index != undefined) {
      // bằng 0 vẫn ok nhé
      let item = state.items[index];
      if (item[key] === id) {
        fields.forEach((field) => {
          item[field] = data[field];
        });
      }
    } else {
      for (let i = 0; i < state.items.length; i++) {
        let item = state.items[i];
        if (item[key] === id) {
          fields.forEach((field) => {
            item[field] = data[field];
          });
        }
      }
    }
  },
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
